import { get, put } from "../index";
import PaymentRoutes from "./Payment.routes";

const PaymentServices = {
  getPaymentMethodStatus: async () => {
    const result = await get(PaymentRoutes.getPaymentMethodStatus);
    return result;
  },

  updatePaymentMethodStatus: async (obj) => {
    const result = await put(PaymentRoutes.updatePaymentMethodStatus, obj);
    return result;
  },

  getEscrowAccountLedger: async (page, limit, role, adId, user_id, from, to) => {
    const result = await get(PaymentRoutes.getEscrowAccountLedger +
      `?page=${page}&limit=${limit}&role=${role}&adId=${adId}&user_id=${user_id}&from=${from}&to=${to}`);
    return result;
  },
}

export default PaymentServices;